<template>
  <div
    class="limited-time-pos"
    @click.stop="onUpgradeClick"
    v-if="isCN() && userInfo?.user_id && !checkPermission(PermissionActionKey.NO_LIMITED_TIME)"
  >
    <Tooltip
      :content="
        $t(
          'bian-ji-gong-neng-xian-shi-ti-yan-ru-xu-ti-yan-wan-zheng-gong-neng-qing-sheng-ji-quan-yi',
        )
      "
    >
      <div class="limited-time-tag">{{ $t('xian-shi') }}</div>
    </Tooltip>
  </div>
</template>

<script lang="ts" setup>
import { showBuyEquityModal } from '@rendora/common/features/payment/ui/buy-equity';
import { useUserStore } from '@rendora/common/store';
import { checkPermission, PermissionActionKey } from '@rendora/common/store/userPermission';
import { ASSET_TYPE, IRightsType } from '@rendora/common/types/enums';
import { isCN } from '@rendora/common/utils/config';
import Tooltip from '@rendora/design/components/tooltip/Tooltip.vue';

const userInfo = useUserStore().user;

const emits = defineEmits(['cancel']);

const props = withDefaults(
  defineProps<{
    config_type?: number;
    tab?: 'character' | 'scene' | 'tts_vcn' | 'feature';
  }>(),
  {
    config_type: ASSET_TYPE.COMMON,
    tab: 'character',
  },
);

const onUpgradeClick = () => {
  emits('cancel');
  showBuyEquityModal({
    targetType: (props.config_type as IRightsType) || undefined,
  });
};
</script>

<style lang="scss" scoped>
.limited-time-pos {
  position: absolute;
  right: -8px;
  top: -8px;
}

.limited-time-tag {
  border: 1px solid var(--x-purple-3);
  color: var(--x-purple-6);
  border-radius: var(--x-radius-small);
  padding: 0px 4px;
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  background: var(--x-back-1);
  letter-spacing: normal;
}
</style>
